// Countdown timer for the flash sale block.
// Guarded so multiple instances of the block on one page register once.
if (!customElements.get('tk-countdown')) {
  customElements.define(
    'tk-countdown',
    class extends HTMLElement {
      connectedCallback() {
        this.target = new Date(this.dataset.ends).getTime();
        if (Number.isNaN(this.target)) return;

        this.fields = {};
        this.querySelectorAll('[data-unit]').forEach((el) => {
          this.fields[el.dataset.unit] = el;
        });
        this.units = this.querySelector('.tk-flash__units');
        this.over = this.querySelector('.tk-flash__over');

        this.tick();
        this.timer = setInterval(() => this.tick(), 1000);
      }

      disconnectedCallback() {
        clearInterval(this.timer);
      }

      tick() {
        const left = this.target - Date.now();

        if (left <= 0) {
          clearInterval(this.timer);
          this.finish();
          return;
        }

        const s = Math.floor(left / 1000);
        this.set('days', Math.floor(s / 86400));
        this.set('hours', Math.floor((s % 86400) / 3600));
        this.set('minutes', Math.floor((s % 3600) / 60));
        this.set('seconds', s % 60);
      }

      set(unit, value) {
        const el = this.fields[unit];
        const next = String(value).padStart(2, '0');
        if (el && el.textContent !== next) el.textContent = next;
      }

      finish() {
        if (this.dataset.expired === 'hide') {
          const block = this.closest('.tk-flash');
          if (block) block.hidden = true;
          return;
        }
        Object.values(this.fields).forEach((el) => {
          el.textContent = '00';
        });
        if (this.dataset.expired === 'message' && this.over) {
          this.units.hidden = true;
          this.over.hidden = false;
        }
      }
    }
  );
}